import { jsx, jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect, useMemo } from "react";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import MuiSelect from "@mui/material/Select";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
function Select({
  id,
  label,
  variant = "filled",
  maxWidth = "100%",
  options,
  noOptionsText = "No Options Available",
  children: originalChildren,
  fullWidth = true,
  helperText,
  sx = {},
  formControlSx = {},
  MenuProps,
  InputLabelProps,
  ...props
}) {
  var _a;
  const [menuMinWidth, setMenuMinWidth] = useState("");
  const inputRef = useRef(null);
  useEffect(() => {
    const handleResize = () => {
      var _a2;
      return setMenuMinWidth((_a2 = inputRef.current) == null ? void 0 : _a2.node.offsetWidth);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const children = useMemo(() => {
    if (originalChildren) {
      return originalChildren;
    }
    if (typeof options !== "undefined" && (options == null ? void 0 : options.length) > 0) {
      return options.map((option) => /* @__PURE__ */ jsx(MenuItem, { value: option.value, children: option.label }, option.value));
    }
    return /* @__PURE__ */ jsx(MenuItem, { disabled: true, children: noOptionsText });
  }, [originalChildren, options, noOptionsText]);
  return /* @__PURE__ */ jsxs(FormControl, { fullWidth, sx: {
    ...formControlSx
  }, children: [
    !!label && /* @__PURE__ */ jsx(InputLabel, { required: props.required, variant, id: id ? `${id}-label` : void 0, ...InputLabelProps, children: label }),
    /* @__PURE__ */ jsx(MuiSelect, { labelId: id && label ? `${id}-label` : void 0, id, label, variant, color: "secondary", inputRef, IconComponent: ExpandMoreIcon, autoWidth: true, sx: {
      maxWidth,
      ...sx
    }, MenuProps: {
      ...MenuProps,
      sx: {
        ...MenuProps == null ? void 0 : MenuProps.sx,
        ".MuiMenu-paper": {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          ...(_a = MenuProps == null ? void 0 : MenuProps.sx) == null ? void 0 : _a[".MuiMenu-paper"],
          minWidth: menuMinWidth
        }
      }
    }, ...props, children }),
    helperText && /* @__PURE__ */ jsx(FormHelperText, { children: helperText })
  ] });
}
export {
  Select
};
//# sourceMappingURL=index.js.map
